/**
 * Caminhos Firestore alvo (desmanche de data/main).
 * Única fonte de nomes de coleção/documento para a camada de repos.
 */

/** @type {const} */
export const MESSA_FS = {
  dataMain: { collection: 'data', docId: 'main' },
  clients: 'clients',
  scripts: 'scripts',
  productions: 'productions',
  productionGroups: 'productionGroups',
  /** Doc único: estados da agenda (split de `data/main`). Os acessos saíram daqui na 3.1b. */
  agendaSettings: { collection: 'agendaSettings', docId: 'main' },
  /** Doc único: cofre dos acessos do cliente (login/senha) — regra própria (3.1b). */
  clientAcessos: { collection: 'clientAcessos', docId: 'main' },
  /** Doc único: sazonais + campanhas (evita dois reads na UI). */
  seasonalSettings: { collection: 'seasonalSettings', docId: 'main' },
  /** Doc único: fingerprints / estado de sync (ex-GCal) desacoplado de sazonais se quiserem partir depois. */
  calendarSync: { collection: 'calendarSync', docId: 'main' },
  /** Comentários por produção (subcoleção). */
  productionComments: 'comments',
  /** Doc único: gestão de tráfego pago (contas + snapshots de métricas). */
  trafego: { collection: 'trafego', docId: 'main' },
  /** Relatório semanal de Instagram orgânico por cliente (coleção, key = clientId). */
  contentReports: 'contentReports',
  contentClientSettings: 'contentClientSettings',
  /** Doc único: config do CRM (responsável padrão de leads, contato das propostas). */
  crmSettings: { collection: 'crmSettings', docId: 'main' },
  /** Doc único: textos das notificações automáticas (templates editáveis). */
  notifSettings: { collection: 'notifSettings', docId: 'main' },
};
